export default __webpack_public_path__ + "static/media/cover.e08b2117.jpg";